export default {
  getTax: (state) => (taxId) => state.taxes.find((t) => t.taxId === taxId),
  taxesLoaded: (state) => state.taxes.length > 0,
};
